import _toConsumableArray from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectWithoutProperties from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["url"],
  _excluded2 = ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"],
  _excluded3 = ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"],
  _excluded4 = ["headers"],
  _excluded5 = ["errors"];
import _regeneratorRuntime from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defaultJsonSerializer } from './defaultJsonSerializer.js';
import { HeadersInstanceToPlainObject, uppercase } from './helpers.js';
import { parseBatchRequestArgs, parseRawRequestArgs, parseRawRequestExtendedArgs, parseRequestArgs, parseRequestExtendedArgs } from './parseArgs.js';
import { resolveRequestDocument } from './resolveRequestDocument.js';
import { ClientError } from './types.js';
import crossFetch, * as CrossFetch from 'cross-fetch';
/**
 * Convert the given headers configuration into a plain object.
 */
var resolveHeaders = function resolveHeaders(headers) {
  var oHeaders = {};
  if (headers) {
    if (typeof Headers !== "undefined" && headers instanceof Headers || CrossFetch && CrossFetch.Headers && headers instanceof CrossFetch.Headers) {
      oHeaders = HeadersInstanceToPlainObject(headers);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          value = _ref2[1];
        if (name && value !== undefined) {
          oHeaders[name] = value;
        }
      });
    } else {
      oHeaders = headers;
    }
  }
  return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */
var cleanQuery = function cleanQuery(str) {
  return str.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim();
};
/**
 * Create query string for GraphQL request
 */
var buildRequestConfig = function buildRequestConfig(params) {
  if (!Array.isArray(params.query)) {
    var _params_ = params;
    var search = ["query=".concat(encodeURIComponent(cleanQuery(_params_.query)))];
    if (params.variables) {
      search.push("variables=".concat(encodeURIComponent(_params_.jsonSerializer.stringify(_params_.variables))));
    }
    if (_params_.operationName) {
      search.push("operationName=".concat(encodeURIComponent(_params_.operationName)));
    }
    return search.join("&");
  }
  if (typeof params.variables !== "undefined" && !Array.isArray(params.variables)) {
    throw new Error("Cannot create query with given variable type, array expected");
  }
  // Batch support
  var params_ = params;
  var payload = params.query.reduce(function (acc, currentQuery, index) {
    acc.push({
      query: cleanQuery(currentQuery),
      variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
    });
    return acc;
  }, []);
  return "query=".concat(encodeURIComponent(params_.jsonSerializer.stringify(payload)));
};
var createHttpMethodFetcher = function createHttpMethodFetcher(method) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var url, query, variables, operationName, fetch, fetchOptions, middleware, headers, queryParams, body, _fetchOptions$jsonSer, init, urlResolved, initResolved, result, urlNew, initNew;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = params.url, query = params.query, variables = params.variables, operationName = params.operationName, fetch = params.fetch, fetchOptions = params.fetchOptions, middleware = params.middleware;
              headers = _objectSpread({}, params.headers);
              queryParams = "";
              body = undefined;
              if (method === "POST") {
                body = createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
                if (typeof body === "string") {
                  // @ts-expect-error todo
                  headers["Content-Type"] = "application/json";
                }
              } else {
                // @ts-expect-error todo needs ADT for TS to understand the different states
                queryParams = buildRequestConfig({
                  query: query,
                  variables: variables,
                  operationName: operationName,
                  jsonSerializer: (_fetchOptions$jsonSer = fetchOptions.jsonSerializer) !== null && _fetchOptions$jsonSer !== void 0 ? _fetchOptions$jsonSer : defaultJsonSerializer
                });
              }
              init = _objectSpread({
                method: method,
                headers: headers,
                body: body
              }, fetchOptions);
              urlResolved = url;
              initResolved = init;
              if (!middleware) {
                _context.next = 15;
                break;
              }
              _context.next = 11;
              return Promise.resolve(middleware(_objectSpread(_objectSpread({}, init), {}, {
                url: url,
                operationName: operationName,
                variables: variables
              })));
            case 11:
              result = _context.sent;
              urlNew = result.url, initNew = _objectWithoutProperties(result, _excluded);
              urlResolved = urlNew;
              initResolved = initNew;
            case 15:
              if (queryParams) {
                urlResolved = "".concat(urlResolved, "?").concat(queryParams);
              }
              _context.next = 18;
              return fetch(urlResolved, initResolved);
            case 18:
              return _context.abrupt("return", _context.sent);
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * GraphQL Client.
 */
var GraphQLClient = /*#__PURE__*/function () {
  function GraphQLClient(url) {
    var _this = this;
    var requestConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, GraphQLClient);
    this.url = url;
    this.requestConfig = requestConfig;
    /**
     * Send a GraphQL query to the server.
     */
    this.rawRequest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _len,
        args,
        _key,
        queryOrOptions,
        variables,
        requestHeaders,
        rawRequestOptions,
        _this$requestConfig,
        headers,
        _this$requestConfig$f,
        fetch,
        _this$requestConfig$m,
        method,
        requestMiddleware,
        responseMiddleware,
        fetchOptions,
        url,
        _resolveRequestDocume,
        operationName,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args2[_key];
              }
              queryOrOptions = args[0], variables = args[1], requestHeaders = args[2];
              rawRequestOptions = parseRawRequestArgs(queryOrOptions, variables, requestHeaders);
              _this$requestConfig = _this.requestConfig, headers = _this$requestConfig.headers, _this$requestConfig$f = _this$requestConfig.fetch, fetch = _this$requestConfig$f === void 0 ? crossFetch : _this$requestConfig$f, _this$requestConfig$m = _this$requestConfig.method, method = _this$requestConfig$m === void 0 ? "POST" : _this$requestConfig$m, requestMiddleware = _this$requestConfig.requestMiddleware, responseMiddleware = _this$requestConfig.responseMiddleware, fetchOptions = _objectWithoutProperties(_this$requestConfig, _excluded2);
              url = _this.url;
              if (rawRequestOptions.signal !== undefined) {
                fetchOptions.signal = rawRequestOptions.signal;
              }
              _resolveRequestDocume = resolveRequestDocument(rawRequestOptions.query), operationName = _resolveRequestDocume.operationName;
              return _context2.abrupt("return", makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: _objectSpread(_objectSpread({}, resolveHeaders(callOrIdentity(headers))), resolveHeaders(rawRequestOptions.requestHeaders)),
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
              }).then(function (response) {
                if (responseMiddleware) {
                  responseMiddleware(response);
                }
                return response;
              }).catch(function (error) {
                if (responseMiddleware) {
                  responseMiddleware(error);
                }
                throw error;
              }));
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }
  _createClass(GraphQLClient, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(documentOrOptions) {
        var _len2,
          variablesAndRequestHeaders,
          _key2,
          variables,
          requestHeaders,
          requestOptions,
          _this$requestConfig2,
          headers,
          _this$requestConfig2$,
          fetch,
          _this$requestConfig2$2,
          method,
          requestMiddleware,
          responseMiddleware,
          fetchOptions,
          url,
          _resolveRequestDocume2,
          query,
          operationName,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (_len2 = _args3.length, variablesAndRequestHeaders = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  variablesAndRequestHeaders[_key2 - 1] = _args3[_key2];
                }
                variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
                requestOptions = parseRequestArgs(documentOrOptions, variables, requestHeaders);
                _this$requestConfig2 = this.requestConfig, headers = _this$requestConfig2.headers, _this$requestConfig2$ = _this$requestConfig2.fetch, fetch = _this$requestConfig2$ === void 0 ? crossFetch : _this$requestConfig2$, _this$requestConfig2$2 = _this$requestConfig2.method, method = _this$requestConfig2$2 === void 0 ? "POST" : _this$requestConfig2$2, requestMiddleware = _this$requestConfig2.requestMiddleware, responseMiddleware = _this$requestConfig2.responseMiddleware, fetchOptions = _objectWithoutProperties(_this$requestConfig2, _excluded3);
                url = this.url;
                if (requestOptions.signal !== undefined) {
                  fetchOptions.signal = requestOptions.signal;
                }
                _resolveRequestDocume2 = resolveRequestDocument(requestOptions.document), query = _resolveRequestDocume2.query, operationName = _resolveRequestDocume2.operationName;
                return _context3.abrupt("return", makeRequest({
                  url: url,
                  query: query,
                  variables: requestOptions.variables,
                  headers: _objectSpread(_objectSpread({}, resolveHeaders(callOrIdentity(headers))), resolveHeaders(requestOptions.requestHeaders)),
                  operationName: operationName,
                  fetch: fetch,
                  method: method,
                  fetchOptions: fetchOptions,
                  middleware: requestMiddleware
                }).then(function (response) {
                  if (responseMiddleware) {
                    responseMiddleware(response);
                  }
                  return response.data;
                }).catch(function (error) {
                  if (responseMiddleware) {
                    responseMiddleware(error);
                  }
                  throw error;
                }));
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function request(_x2) {
        return _request.apply(this, arguments);
      }
      return request;
    }() // prettier-ignore
  }, {
    key: "batchRequests",
    value: function batchRequests(documentsOrOptions, requestHeaders) {
      var _this$requestConfig$f2,
        _this2 = this;
      var batchRequestOptions = parseBatchRequestArgs(documentsOrOptions, requestHeaders);
      var _this$requestConfig3 = this.requestConfig,
        headers = _this$requestConfig3.headers,
        fetchOptions = _objectWithoutProperties(_this$requestConfig3, _excluded4);
      if (batchRequestOptions.signal !== undefined) {
        fetchOptions.signal = batchRequestOptions.signal;
      }
      var queries = batchRequestOptions.documents.map(function (_ref5) {
        var document = _ref5.document;
        return resolveRequestDocument(document).query;
      });
      var variables = batchRequestOptions.documents.map(function (_ref6) {
        var variables = _ref6.variables;
        return variables;
      });
      return makeRequest({
        url: this.url,
        query: queries,
        // @ts-expect-error TODO reconcile batch variables into system.
        variables: variables,
        headers: _objectSpread(_objectSpread({}, resolveHeaders(callOrIdentity(headers))), resolveHeaders(batchRequestOptions.requestHeaders)),
        operationName: undefined,
        fetch: (_this$requestConfig$f2 = this.requestConfig.fetch) !== null && _this$requestConfig$f2 !== void 0 ? _this$requestConfig$f2 : crossFetch,
        method: this.requestConfig.method || "POST",
        fetchOptions: fetchOptions,
        middleware: this.requestConfig.requestMiddleware
      }).then(function (response) {
        if (_this2.requestConfig.responseMiddleware) {
          _this2.requestConfig.responseMiddleware(response);
        }
        return response.data;
      }).catch(function (error) {
        if (_this2.requestConfig.responseMiddleware) {
          _this2.requestConfig.responseMiddleware(error);
        }
        throw error;
      });
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(headers) {
      this.requestConfig.headers = headers;
      return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
  }, {
    key: "setHeader",
    value: function setHeader(key, value) {
      var headers = this.requestConfig.headers;
      if (headers) {
        // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
      } else {
        this.requestConfig.headers = _defineProperty({}, key, value);
      }
      return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
  }, {
    key: "setEndpoint",
    value: function setEndpoint(value) {
      this.url = value;
      return this;
    }
  }]);
  return GraphQLClient;
}();
var makeRequest = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _params$method, _fetchOptions$jsonSer2;
    var query, variables, fetchOptions, fetcher, isBatchingQuery, response, result, successfullyReceivedData, successfullyPassedErrorPolicy, _ref9, _, rest, data, dataEnvelope, errorResult;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            query = params.query, variables = params.variables, fetchOptions = params.fetchOptions;
            fetcher = createHttpMethodFetcher(uppercase((_params$method = params.method) !== null && _params$method !== void 0 ? _params$method : "post"));
            isBatchingQuery = Array.isArray(params.query);
            _context4.next = 5;
            return fetcher(params);
          case 5:
            response = _context4.sent;
            _context4.next = 8;
            return getResult(response, (_fetchOptions$jsonSer2 = fetchOptions.jsonSerializer) !== null && _fetchOptions$jsonSer2 !== void 0 ? _fetchOptions$jsonSer2 : defaultJsonSerializer);
          case 8:
            result = _context4.sent;
            successfullyReceivedData = Array.isArray(result) ? !result.some(function (_ref8) {
              var data = _ref8.data;
              return !data;
            }) : Boolean(result.data);
            successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === "all" || fetchOptions.errorPolicy === "ignore";
            if (!(response.ok && successfullyPassedErrorPolicy && successfullyReceivedData)) {
              _context4.next = 18;
              break;
            }
            // @ts-expect-error TODO fixme
            _ref9 = Array.isArray(result) ? result : result, _ = _ref9.errors, rest = _objectWithoutProperties(_ref9, _excluded5);
            data = fetchOptions.errorPolicy === "ignore" ? rest : result;
            dataEnvelope = isBatchingQuery ? {
              data: data
            } : data; // @ts-expect-error TODO
            return _context4.abrupt("return", _objectSpread(_objectSpread({}, dataEnvelope), {}, {
              headers: response.headers,
              status: response.status
            }));
          case 18:
            errorResult = typeof result === "string" ? {
              error: result
            } : result;
            throw new ClientError( // @ts-expect-error TODO
            _objectSpread(_objectSpread({}, errorResult), {}, {
              status: response.status,
              headers: response.headers
            }), {
              query: query,
              variables: variables
            });
          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function makeRequest(_x3) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
var rawRequest = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var _len3,
      args,
      _key3,
      urlOrOptions,
      query,
      variablesAndRequestHeaders,
      requestOptions,
      client,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            for (_len3 = _args5.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = _args5[_key3];
            }
            urlOrOptions = args[0], query = args[1], variablesAndRequestHeaders = args.slice(2);
            requestOptions = parseRawRequestExtendedArgs.apply(void 0, [urlOrOptions, query].concat(_toConsumableArray(variablesAndRequestHeaders)));
            client = new GraphQLClient(requestOptions.url);
            return _context5.abrupt("return", client.rawRequest(_objectSpread({}, requestOptions)));
          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function rawRequest() {
    return _ref10.apply(this, arguments);
  };
}();
// prettier-ignore
// eslint-disable-next-line
function request(_x4, _x5) {
  return _request2.apply(this, arguments);
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
function _request2() {
  _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(urlOrOptions, document) {
    var _len4,
      variablesAndRequestHeaders,
      _key4,
      requestOptions,
      client,
      _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            for (_len4 = _args8.length, variablesAndRequestHeaders = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
              variablesAndRequestHeaders[_key4 - 2] = _args8[_key4];
            }
            requestOptions = parseRequestExtendedArgs.apply(void 0, [urlOrOptions, document].concat(variablesAndRequestHeaders));
            client = new GraphQLClient(requestOptions.url);
            return _context8.abrupt("return", client.request(_objectSpread({}, requestOptions)));
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _request2.apply(this, arguments);
}
var batchRequests = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _len5,
      args,
      _key5,
      params,
      client,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            for (_len5 = _args6.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              args[_key5] = _args6[_key5];
            }
            params = parseBatchRequestsArgsExtended(args);
            client = new GraphQLClient(params.url);
            return _context6.abrupt("return", client.batchRequests(params));
          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function batchRequests() {
    return _ref11.apply(this, arguments);
  };
}();
var parseBatchRequestsArgsExtended = function parseBatchRequestsArgsExtended(args) {
  if (args.length === 1) {
    return args[0];
  } else {
    return {
      url: args[0],
      documents: args[1],
      requestHeaders: args[2],
      signal: undefined
    };
  }
};
var createRequestBody = function createRequestBody(query, variables, operationName, jsonSerializer) {
  var jsonSerializer_ = jsonSerializer !== null && jsonSerializer !== void 0 ? jsonSerializer : defaultJsonSerializer;
  if (!Array.isArray(query)) {
    return jsonSerializer_.stringify({
      query: query,
      variables: variables,
      operationName: operationName
    });
  }
  if (typeof variables !== "undefined" && !Array.isArray(variables)) {
    throw new Error("Cannot create request body with given variable type, array expected");
  }
  // Batch support
  var payload = query.reduce(function (acc, currentQuery, index) {
    acc.push({
      query: currentQuery,
      variables: variables ? variables[index] : undefined
    });
    return acc;
  }, []);
  return jsonSerializer_.stringify(payload);
};
var getResult = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(response, jsonSerializer) {
    var contentType;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            response.headers.forEach(function (value, key) {
              if (key.toLowerCase() === "content-type") {
                contentType = value;
              }
            });
            if (!(contentType && (contentType.toLowerCase().startsWith("application/json") || contentType.toLowerCase().startsWith("application/graphql+json") || contentType.toLowerCase().startsWith("application/graphql-response+json")))) {
              _context7.next = 9;
              break;
            }
            _context7.t0 = jsonSerializer;
            _context7.next = 5;
            return response.text();
          case 5:
            _context7.t1 = _context7.sent;
            return _context7.abrupt("return", _context7.t0.parse.call(_context7.t0, _context7.t1));
          case 9:
            return _context7.abrupt("return", response.text());
          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function getResult(_x6, _x7) {
    return _ref12.apply(this, arguments);
  };
}();
var callOrIdentity = function callOrIdentity(value) {
  return typeof value === "function" ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
export var gql = function gql(chunks) {
  for (var _len6 = arguments.length, variables = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    variables[_key6 - 1] = arguments[_key6];
  }
  return chunks.reduce(function (acc, chunk, index) {
    return "".concat(acc).concat(chunk).concat(index in variables ? String(variables[index]) : "");
  }, "");
};
export { GraphQLWebSocketClient } from './graphql-ws.js';
export { resolveRequestDocument } from './resolveRequestDocument.js';
export { batchRequests, ClientError, GraphQLClient, rawRequest, request };
export default request;